import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../child/Loder";
import DengerAlert from "../child/Alert/DengerAlert";
import moment from "moment";
import { fetchDiscoveryConfigById } from "../services/discoveryConfigService";
// 👆 make sure you have this service

const ViewDiscoveryConfigPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("config-info");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        setError("");
        const res = await fetchDiscoveryConfigById(id); // call service
        setConfig(res?.data || null); // adjust based on API response shape
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch config");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchConfig();
  }, [id]);

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {error && (
              <DengerAlert message={error} onClose={() => setError("")} />
            )}

            {/* Tabs */}
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "config-info" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("config-info")}
                  type="button"
                  role="tab"
                >
                  Config Info
                </button>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content">
              {/* Config Info Tab */}
              <div
                className={`tab-pane fade ${activeTab === "config-info" ? "show active" : ""
                  }`}
                role="tabpanel"
              >
                {config ? (
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Name:
                      </label>
                      {config.name || "N/A"}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Status:
                      </label>
                      {config.isActive ? "Active" : "Inactive"}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Created At:
                      </label>
                      {moment(config.createdAt).format("DD-MM-YYYY")}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Updated At:
                      </label>
                      {moment(config.updatedAt).format("DD-MM-YYYY")}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Matching Preferences:
                      </label>
                      {config.weights.dynamicAnswers}
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Gatekeeper Compatibility :
                      </label>

                      {config.weights.gatekeeper}
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Profile Completeness:
                      </label>
                      {config.weights.profileSteps}
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                       Connection Intent Compatibility:
                      </label>
                      {config.weights.connectionIntent}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Photos:
                      </label>
                      {config.weights.photos}
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Vault Alignment:
                      </label>
                      {config.weights.vault ?? 0}
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Minimum Displayed Compatibility (%):
                      </label>
                      {config.minDisplayPercent ?? 75}
                    </div>


                    {/* Distance */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Location Weight:
                      </label>
                      <ul
                        className="mb-0 ps-3"
                        style={{ listStyleType: "disc" }}
                      >
                        <li>Near: {config.weights.distance?.near}</li>
                        <li>Medium: {config.weights.distance?.medium}</li>
                        <li>Far: {config.weights.distance?.far}</li>
                        <li>Very Far: {config.weights.distance?.veryFar}</li>
                      </ul>
                    </div>

                    {/* Last Seen */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Recent Activity Weights:
                      </label>

                      <ul
                        className="mb-0 ps-3"
                        style={{ listStyleType: "disc" }}
                      >
                        <li>Day: {config.weights.lastSeen?.day}</li>
                        <li>3 Days: {config.weights.lastSeen?.threeDays}</li>
                        <li>Week: {config.weights.lastSeen?.week}</li>
                      </ul>
                    </div>

                    {/* Daily Question overlap (matching, 0 = off) */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Daily Question Overlap:
                      </label>
                      {config.weights.dailyAnswers ?? 0}
                      {!(config.weights.dailyAnswers > 0) && (
                        <span className="text-muted ms-2">(off)</span>
                      )}
                    </div>

                    {/* Age proximity (ranking only) */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Age Proximity (ranking only):
                      </label>
                      <ul
                        className="mb-0 ps-3"
                        style={{ listStyleType: "disc" }}
                      >
                        <li>Close, within 3 years: {config.weights.ageProximity?.close ?? 10}</li>
                        <li>Near, within 8 years: {config.weights.ageProximity?.near ?? 5}</li>
                      </ul>
                    </div>

                    {/* Liveness penalties (ranking only) */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold me-2 mb-0">
                        Liveness Penalties (ranking only):
                      </label>
                      <ul
                        className="mb-0 ps-3"
                        style={{ listStyleType: "disc" }}
                      >
                        <li>No push token: {config.weights.liveness?.unreachable ?? 8}</li>
                        <li>Not seen in 7 days: {config.weights.liveness?.absent ?? 8}</li>
                      </ul>
                    </div>


                  </div>
                ) : (
                  <div>No Config Found</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDiscoveryConfigPage;
